import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const COUPON_MENU: PermissionTableRowType = {
  name: '쿠폰',
  key: 'COUPON_MANAGE',
  subRows: [
    {
      name: '쿠폰 관리',
      key: PERMISSION_SUBJECTS.COUPON,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.COUPON,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '쿠폰/쿠폰 발급 내역 상세',
          key: PERMISSION_SUBJECTS.COUPON,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '쿠폰 발급/쿠폰생성',
          key: PERMISSION_SUBJECTS.COUPON,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '쿠폰 편집',
          key: PERMISSION_SUBJECTS.COUPON,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
  ],
};
